
import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "./api/baseApi";
import authReducer from "./slices/authSlice"; // <-- make sure this path matches your project

// optional helper to enable RTK Query listeners (refetchOnFocus, refetchOnReconnect)
import { setupListeners } from "@reduxjs/toolkit/query";

const store = configureStore({
  reducer: {
    // auth slice (persisted to localStorage inside the slice reducer)
    auth: authReducer,

    // RTK Query generated reducer
    [baseApi.reducerPath]: baseApi.reducer,
  },
  // Adding the api middleware enables caching, invalidation, polling, and other RTK Query features
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
  devTools: process.env.NODE_ENV !== "production",
});

// enable optional listeners for refetchOnFocus/refetchOnReconnect
setupListeners(store.dispatch);

export default store;

